import {Button, Dropdown, Flex, Input, MenuProps, Modal, Space, Typography} from "antd";
import React, {useEffect} from "react";
import '@mdxeditor/editor/style.css';
import {MDXEditor} from '@mdxeditor/editor';
import {TagFlow} from "../../components/TagFlow";
import {Tag} from "../../feature/project/fields";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useParams} from "react-router-dom";
import {Status} from "../../feature/project/status";
import {fetchTags} from "../../feature/project/projectsSlice";
import {
    addShotTag,
    removeShotTag
} from "../../feature/project/shotSlice";
import {Shot} from "../../feature/project/Shot";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown} from "@fortawesome/free-solid-svg-icons";
import {fetchLore} from "../../feature/project/loreSlice";
import {Component} from "../../feature/project/setting";
import {fetchStorySetting} from "../../feature/project/settingsSlice";

export interface ShotProps {
    shot: Shot,
    visible: boolean,
    onCancel: () => void,
    onSave: (shot: Shot) => void,
}

export const AddShotModal = (props: ShotProps) => {
    const dispatch = useAppDispatch();
    const {projectId} = useParams();
    const allTags = useAppSelector(state => state.projects.tags)
    const status = useAppSelector(state => state.components.status)
    const story = useAppSelector(state => state.stories.story)
    const setting = useAppSelector(state => state.settings.storySetting)
    const [hasChanges, setHasChanges] = React.useState(false)
    const [description, setDescription] = React.useState(props.shot.description)
    const [tags, setTags] = React.useState<Array<Tag>>(props.shot.tags || [])
    const [environment, setType] = React.useState(props.shot.environment || "Interior")
    const [time, setTime] = React.useState(props.shot.time || "Day")
    const [place, setPlace] = React.useState(props.shot.place || "")

    useEffect(() => {
        setDescription(props.shot.description || '')
        setTags(props.shot.tags || [])
    }, [props.visible, props.shot, props.shot.tags])

    useEffect(() => {
        setHasChanges(description !== props.shot.description || environment !== props.shot.environment || time !== props.shot.time || place !== props.shot.place)
    }, [description, environment, time, place])

    useEffect(() => {
        if (status == Status.Idle && projectId && props.visible) {
            if (props.shot.id) {
                dispatch(fetchTags({projectId: parseInt(projectId)}))
            }
        }
    }, [status, dispatch, story])

    useEffect(() => {
        if (story?.settingId && projectId) {
            dispatch(fetchStorySetting({settingId: story.settingId, projectId: parseInt(projectId)}))
        }
    }, [story, projectId]);

    var places: MenuProps = {
        items: setting?.components?.filter((c: Component) => c.category?.title === "Location").map((c) => {
            return {
                label: c.title,
                key: c.title
            }
        }) || [],
        onClick: (item) => {
            setPlace(item.key)
        }
    }

    useEffect(() => {
        places = {
            items: setting?.components?.filter((c: Component) => c.category?.title === "Location").map((c) => {
                return {
                    label: c.title,
                    key: c.title
                }
            }) || [],
            onClick: (item) => {
                setPlace(item.key)
            }
        }
    }, [setting]);



    const env: MenuProps = {
        items: [
            {
                label: "Interior",
                key: "Interior" //e.g. set variable - "value", increment - "{variableName}+1"
            },
            {
                label: "Exterior",
                key: "Exterior" //e.g. logical parameter - name: when, value: start, name: delay, value: 1000
            },
        ],
        onClick: (item) => {
            setType(item.key)
        }
    }

    const t: MenuProps = {
        items: [
            {
                label: "Day",
                key: "Day" //e.g. set variable - "value", increment - "{variableName}+1"
            },
            {
                label: "Morning",
                key: "Morning" //e.g. logical parameter - name: when, value: start, name: delay, value: 1000
            },
            {
                label: "Evening",
                key: "Evening" //e.g. logical parameter - name: when, value: start, name: delay, value: 1000
            },
            {
                label: "Night",
                key: "Night" //e.g. logical parameter - name: when, value: start, name: delay, value: 1000
            },
        ],
        onClick: (item) => {
            setTime(item.key)
        }
    }

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={props.shot.id ? 'Edit Shot' : `Add Shot`}
            okText={'Save'}
            okButtonProps={{disabled: !hasChanges}}
            onCancel={() => {
                props.onCancel()
            }}
            onOk={() => {
                props.onSave({
                    id: props.shot.id,
                    title: props.shot.title,
                    description: description || "",
                    tags: tags,
                    actions: props.shot.actions,
                    shots: props.shot.shots,
                    environment: environment,
                    time: time,
                    place: place
                })
            }

            }
            width={600}
        >

            <Flex gap={16}>
                <Space direction={'vertical'} style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}}
                       size={16}>
                    <Space direction={'vertical'} style={{width: "100%"}}>
                        <Flex style={{width: "100%", display: 'flex'}} gap={10}>
                            <Dropdown
                                menu={env} trigger={["click"]}>
                                <Button>
                                    <Flex align={'center'}
                                          justify={'space-between'}
                                          gap={10}> {environment}
                                        <FontAwesomeIcon icon={faAngleDown}/></Flex>
                                </Button>
                            </Dropdown>
                            {/*<Input style={{flexGrow: 1}} value={place} onChange={(e) => setPlace(e.target.value)}/>*/}
                            <Dropdown
                                menu={places} trigger={["click"]}>
                                <Button  style={{flexGrow: 1}}>
                                    <Flex align={'center'}
                                          justify={'space-between'}
                                          gap={10}><span>{place}</span>
                                        <FontAwesomeIcon icon={faAngleDown}/></Flex>
                                </Button>
                            </Dropdown>
                            <Dropdown
                                menu={t} trigger={["click"]}>
                                <Button>
                                    <Flex align={'center'}
                                          justify={'space-between'}
                                          gap={10}>{time}
                                        <FontAwesomeIcon icon={faAngleDown}/></Flex>
                                </Button>
                            </Dropdown>
                        </Flex>
                        <Typography style={{fontWeight: 700}}>Content</Typography>
                        <MDXEditor
                            className={"markdown-text"}
                            markdown={description || ""}
                            onChange={(e) => setDescription(e)}
                            plugins={[]}
                        />
                    </Space>
                    <div>
                        <Typography style={{fontWeight: 700}}>Tags</Typography>
                        <TagFlow allTags={allTags}
                                 tags={tags}
                                 onTagAdded={(tag) => {
                                     setTags([...tags, tag])
                                     if (props.shot.id && projectId) {
                                         dispatch(addShotTag({
                                             projectId: parseInt(projectId),
                                             shotId: props.shot.id,
                                             tag: {title: tag.title}
                                         }))
                                     }
                                 }}
                                 onTagDeleted={(tag) => {
                                     if (tag.id && props.shot.id && projectId) {
                                         dispatch(removeShotTag({
                                             projectId: parseInt(projectId),
                                             shotId: props.shot.id,
                                             tagId: tag.id
                                         }))
                                     }
                                 }}
                        />
                    </div>
                </Space>
            </Flex>
        </Modal>
    );
}